<template>
    <div class="console-unlogin flex justify-between">
        <!-- 供应商 -->
        <img src="@/assets/home/supplier-login-enter.png" class="console-img" @click="openManagerPage"/>
        <!-- 采购商 -->
        <img src="@/assets/home/buyer-login-enter.png" class="console-img" @click="openManagerPage"/>
    </div>
</template>
<script setup>
  import { useRouter } from "vue-router";
  const router = useRouter();
  // 跳转登录
  function openManagerPage() {
    router.push('/login')
}
</script>
<style lang="scss" scoped> 
.console-unlogin {
    .console-img {
        width: 162px;
        height: 102px;
        border-radius: 10px;
        cursor: pointer;
    }
    .my-console-img{
        width: 457px;
        height: 180px;
        border-radius: 12px;
        cursor: pointer;
    }
}
</style>